// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> axia-residential-arc-living-preferred -> the-gates-at-south-bend
// Generated: 2026-10-01T17:24:19.579Z
// Counts: 5 design, 83 content, 23 slot group, 11 collection binding, 9 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "VALUE",
    "value": "#00306b",
    "mappedField": null
  },
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "VALUE",
    "value": "#00306b",
    "mappedField": null
  },
  "design._site.color.linkVisited": {
    "cssVariable": "--vibe-color-link-visited",
    "overrideType": "VALUE",
    "value": "#00306b",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thoughtfully Designed. Perfectly Located.<br><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome Home to</h1><h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "Explore Tuscaloosa, AL.",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "Your Search Ends Here",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "Live At The Best of Tuscaloosa!",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.heading": {
    "overrideType": "VALUE",
    "customValue": " ",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.intro": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-map.config_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_repli_id"
  },
  "applynowactions.show_application_block": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "contactus.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.height": {
    "overrideType": "VALUE",
    "customValue": "2000",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "preferredemployerprogram.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Exclusive Apartment Offers for Employees in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.scheduler_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "scheduleatour.show_tour_scheduler": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.height": {
    "overrideType": "VALUE",
    "customValue": "1400",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019df438-0904-77bd-a89b-85c68f74db69.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>The best communities make everyday life easier.</strong></p><p>Choose from spacious two and three-bedroom apartments featuring stylish wood-style flooring, private balconies, and convenient in-home washers and dryers. Delight in our picnic area, playground, and well-maintained grounds for an ideal lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 20px;\"><strong>We'd Love to Welcome You Home</strong></span></h2><p>Whether you're ready to move soon or just beginning your apartment search, our leasing team is here to answer your questions and help you find the perfect apartment home.</p><p>Our dedicated leasing team is ready to assist you with any inquiries you may have.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Perfect Space</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 20px;\"><strong>Make Yourself At Home</strong></span></p><p>Whether you're looking for your first apartment or simply more room to grow, The Gates at South Bend offers spacious layouts designed to fit your lifestyle. Explore our available floor plans and find the home that feels just right.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 20px;\"><strong>See Yourself Here!</strong></span></h2><p>Browse our gallery and imagine enjoying your beautifully designed apartment, or coming home to a community you'll be proud to call your own.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 20px;\"><strong>Enjoy Everything Tuscaloosa Has to Offer</strong></span></h2><p>Life at The Gates at South Bend puts you close to everything that makes Tuscaloosa home.</p><p>Spend weekends exploring Tuscaloosa and Birmingham, enjoy nearby parks and recreation, discover local restaurants and coffee shops, or take advantage of convenient access to shopping, schools, and major employers.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 20px;\"><strong>We Love Pets!</strong></span><br>At The Gates at South Bend, we recognize your pets as cherished members of the family. Our pet-friendly apartment community comfortably accommodates up to two companions, ensuring your furry family members can also enjoy the comfort and warmth of your home.</p><p>For more details about our pet policy or specific pet-related needs, please reach out to our dedicated on-site leasing team.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Cats and dogs allowed. Maximum 2 pets per unit. Monthly pet rent: $35 per pet. One-time pet fee: $300–$600 per pet. Breed restrictions apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerprogram.employers_list": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>First Responders</p></li><li><p>Educators</p></li><li><p>Military &amp; Veterans</p></li><li><p>Law Enforcement</p></li><li><p>Delta Airlines</p></li><li><p>Medical Personnel</p></li><li><p>School System Employees</p></li><li><p>Amazon Fulfillment Center</p></li><li><p>Postal Workers</p></li><li><p>Alabama Power</p></li><li><p>Mercedes Benz</p></li><li><p>DCH Medical Center</p></li><li><p>University of Alabama (staff &amp; students)</p></li><li><p>Shelton State Community College (staff &amp; students)</p></li><li><p>Government Employees</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "Your ideal apartment community is nestled in the heart of Tuscaloosa, AL. With a variety of spacious floor plans, including two and three-bedroom options, we cater to your lifestyle and needs. Our well-maintained grounds create a picturesque environment designed for relaxation, while our model home offers a glimpse into the comfort you can call your own.  Experience the convenience of our exceptional amenities, which include access gates for added security and an attentive on-site management team.  Whether you’re enjoying a sunny day at our picnic area, watching your children play in our playground, your happiness is our priority. Each apartment comes equipped with modern features such as stackable washer and dryer units, new carpet, and beautiful wood-style flooring for a stylish touch.   With both 1st and 2nd floor availability, finding the perfect layout is easy. Discover why The Gates at South Bend is the perfect choice for those seeking comfort and community in Tuscaloosa. Don't miss the opportunity to find your new home today! Browse our availability or schedule a tour to visit our vibrant community and experience all that we have to offer!",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Gates at South Bend in Tuscaloosa, AL, our spacious <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">two and three-bedroom floor plans</a> offer the perfect blend of comfort and style. Schedule a tour today and see firsthand why our community feels like home. Curious about resident life? Their testimonials will leave you inspired!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 20px;\"><strong>Ready to envision your new home?</strong></span></p><p>Experience vibrant living spaces tailored to your lifestyle.</p><p>Take a virtual tour today and see all that our community has to offer!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_online_leasing_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "featuring/apartment-with-pool-monroe-30655::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f7-c02e-702e-bf6f-b7c7e1d2d8ae.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor entertainment area with built-in grill, fire pit and seating."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "ctasection.card2_image": {
    "sourceIndex": 3,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d782a-1d01-7767-bf3c-5b8002bae0a3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor seating area with fire pit and built-in grill station"
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[14].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[14].poi_featured_image_media.alt_text"
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[30].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[30].image_media.alt_text"
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f7-b2cc-74af-a15f-b254e96ff229.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f7-995c-70dd-b407-e168d936250e.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d782a-1c65-723d-a83d-48d0260530ce.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02dd-387c-722e-a7a5-14d2ab9c1623.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Gates at South Bend apartment complex exterior with townhome-style buildings and manicured landscaping."
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019fb08f-c5a2-71ef-a54d-07a9cff3cf83.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Man enjoying a sunny day walking his Labrador dog in a peaceful park setting."
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019fb091-458c-7678-92ab-619a716cb7a6.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two people running on treadmills in a gym with a mountain view, promoting fitness."
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[14].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[14].poi_featured_image_media.alt_text"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019fb089-8144-71ca-a768-751090555bcb.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A Bengal cat and Yorkshire Terrier playfully reach for a feathered toy indoors."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02de-5077-741e-8b1d-1c782af373ff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a suburban apartment complex with townhome-style buildings, paved roads, and parked cars."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[29].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[29].image_media.alt_text"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": [
      "custom_f939dd48-2c7b-4ad5-8338-97026f187caf",
      "custom_e882202b-fe86-440c-9f34-31608339445d",
      "custom_e0e24601-e69b-485a-9161-6efbcaabe018",
      "custom_94da2cc5-e909-43a9-9ba5-9e68e9cfc53a",
      "custom_fd7282d4-f502-4672-ad5d-72ac4e6659ae",
      "custom_a7eca17f-219a-42b7-a443-321656e4502d",
      "custom_e33f47a6-84a7-45a6-8747-c6a354959117",
      "custom_7c3f82a1-c104-4ead-bbfc-63208d6b74eb",
      "custom_81fb265f-e919-4ae1-ac62-d411096186c7",
      "custom_b32a5bb4-d0c6-44e8-a3e7-1d0a5af59332",
      "custom_9e463a36-ec59-422d-8763-dce04b625651"
    ],
    "orderedIds": [
      "custom_202bf91a-e912-4fe4-99bd-d09811ab116a",
      "custom_5f54ae92-0e05-4f31-aebe-7264c9457499",
      "custom_00ef1766-b146-4578-bc1d-82c194a11132",
      "custom_85a379b6-63dc-466e-a6f7-1e354ad3f1cd",
      "custom_2b78b8ac-c1ff-4187-bfb4-fc8f5da04a0d",
      "custom_51b14581-6e55-448d-8445-ec96d49387d7",
      "custom_86be3984-ef6c-43da-8cf1-bad22430751b",
      "custom_9e463a36-ec59-422d-8763-dce04b625651",
      "custom_e33f47a6-84a7-45a6-8747-c6a354959117",
      "custom_7c3f82a1-c104-4ead-bbfc-63208d6b74eb",
      "custom_81fb265f-e919-4ae1-ac62-d411096186c7",
      "custom_b32a5bb4-d0c6-44e8-a3e7-1d0a5af59332",
      "custom_fd7282d4-f502-4672-ad5d-72ac4e6659ae",
      "custom_94da2cc5-e909-43a9-9ba5-9e68e9cfc53a",
      "custom_e0e24601-e69b-485a-9161-6efbcaabe018",
      "custom_a7eca17f-219a-42b7-a443-321656e4502d",
      "custom_e882202b-fe86-440c-9f34-31608339445d",
      "custom_a816153a-f09f-4341-b215-99555d42d938",
      "custom_3f1a79bd-03de-486e-84b9-21947183f048",
      "custom_9458ca1e-68c2-458e-b6e9-4c37f2485200",
      "custom_926bda6d-d270-4bba-9537-1fc19ee7d861",
      "custom_4c5b160a-48b7-41af-b22a-f29a752b54ad",
      "custom_f939dd48-2c7b-4ad5-8338-97026f187caf",
      "custom_c6119fa3-f51f-434e-b384-9aa6873e296e",
      "custom_72894cc0-8b0d-4407-a12f-b138e7e24f9c",
      "custom_359b96b8-b955-411f-8038-ce87b493c938",
      "custom_dd8461c4-b51d-46aa-a312-ab26b053cfc7",
      "custom_850fb88e-3052-4820-95c1-be7e0ac28507",
      "custom_92a36cd1-1825-45c6-a59b-6267094f13be",
      "custom_a2c20008-5469-417b-b1bd-7208a9201da4",
      "custom_e78e735d-a40a-46c9-b8ba-fa5a1229231b",
      "custom_698eee70-5cf2-437f-824f-e58a9687df21",
      "custom_4f8f37ec-0b54-42a6-9349-2369df395bd0",
      "custom_3f38ad0a-b75e-4622-8394-283bc9de78ec",
      "custom_cf9a1284-26cd-43bf-bf43-7d2a4770b5bb",
      "custom_9c0ad762-d381-4517-8557-8116d7def818",
      "custom_20206292-17fc-4384-b305-ce8c70f7c6a0"
    ],
    "hiddenIndices": [
      1,
      5,
      23,
      2,
      19,
      4,
      24,
      22,
      21,
      20,
      25
    ],
    "ordering": [
      26,
      3,
      30,
      27,
      29,
      28,
      0,
      25,
      24,
      22,
      21,
      20,
      19,
      2,
      23,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      1,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61,
      62,
      63,
      64,
      65,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      75,
      76,
      77,
      78,
      79,
      80,
      81,
      82,
      83,
      84,
      85,
      86,
      87,
      88,
      89,
      90,
      91,
      92,
      93,
      94,
      95,
      96,
      97,
      98,
      99,
      100,
      101,
      102,
      103,
      104,
      105,
      106,
      107,
      108,
      109,
      110,
      111,
      112,
      113,
      114,
      115,
      116,
      117,
      118,
      119,
      120,
      121,
      122,
      123,
      124,
      125,
      126,
      127,
      128,
      129,
      130,
      131,
      132,
      133
    ],
    "customItems": null
  },
  "amenitieslist.apartmentItems": {
    "limit": null,
    "hiddenIds": [
      "custom_c59fcff7-d772-41f0-960f-df1d7ee05a45",
      "custom_76fcd6cd-fe42-4fe6-9bb9-0cc09fbd53a3",
      "custom_8283a881-d674-4c61-88d3-5ee247cbd879",
      "custom_2920a3f1-d848-44a2-a454-3fd626ad479e",
      "custom_55af916c-3248-4dd0-ba84-cffa7f248260",
      "custom_1793755c-87ba-4cfc-8674-d042f6715878",
      "custom_cc1ce696-b756-4692-8a14-3b9d2386a994",
      "custom_c3002e8e-ebc3-49aa-97f4-4ca85c1363bb",
      "custom_b4ab4120-6fab-4fe5-bf07-a87f11ea4a6c",
      "custom_73ec3114-3536-4c39-8cd9-9a87878979af",
      "custom_f77a2be4-d784-444a-87e2-b4b8c060cadb"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": [
      "custom_4c5b160a-48b7-41af-b22a-f29a752b54ad",
      "custom_c6119fa3-f51f-434e-b384-9aa6873e296e",
      "custom_7c3f82a1-c104-4ead-bbfc-63208d6b74eb",
      "custom_72894cc0-8b0d-4407-a12f-b138e7e24f9c",
      "custom_b32a5bb4-d0c6-44e8-a3e7-1d0a5af59332",
      "custom_e0e24601-e69b-485a-9161-6efbcaabe018",
      "custom_e33f47a6-84a7-45a6-8747-c6a354959117",
      "custom_81fb265f-e919-4ae1-ac62-d411096186c7"
    ],
    "orderedIds": [
      "custom_b32a5bb4-d0c6-44e8-a3e7-1d0a5af59332",
      "custom_e0e24601-e69b-485a-9161-6efbcaabe018",
      "custom_e33f47a6-84a7-45a6-8747-c6a354959117",
      "custom_81fb265f-e919-4ae1-ac62-d411096186c7",
      "custom_4c5b160a-48b7-41af-b22a-f29a752b54ad",
      "custom_7c3f82a1-c104-4ead-bbfc-63208d6b74eb",
      "custom_c6119fa3-f51f-434e-b384-9aa6873e296e",
      "custom_72894cc0-8b0d-4407-a12f-b138e7e24f9c",
      "custom_359b96b8-b955-411f-8038-ce87b493c938",
      "custom_dd8461c4-b51d-46aa-a312-ab26b053cfc7",
      "custom_850fb88e-3052-4820-95c1-be7e0ac28507",
      "custom_92a36cd1-1825-45c6-a59b-6267094f13be",
      "custom_a2c20008-5469-417b-b1bd-7208a9201da4",
      "custom_e78e735d-a40a-46c9-b8ba-fa5a1229231b",
      "custom_fd7282d4-f502-4672-ad5d-72ac4e6659ae"
    ],
    "hiddenIndices": [
      0,
      1,
      12,
      2,
      10,
      13,
      14,
      11
    ],
    "ordering": [
      10,
      13,
      14,
      11,
      0,
      12,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9
    ],
    "customItems": null
  },
  "amenitieslist.communityItems": {
    "limit": null,
    "hiddenIds": [
      "custom_ebaa665e-77f6-4ed0-a9e2-1a0a4167b42b",
      "custom_6d6ad710-2c87-4d69-b81c-afb83ef456f2",
      "custom_799b7559-8d19-4552-8a0f-9ebd33f4e8dd",
      "custom_b0b93022-6593-463c-8103-3a7bb21a2eab",
      "custom_17f4ea3e-4d1d-49e7-9861-473c06e60821",
      "custom_0c9987f9-9ffe-48f7-b261-2383e87da7b8",
      "custom_14d81dd5-c90c-41bc-910e-394014b3c474"
    ],
    "orderedIds": [
      "custom_6bd61ea4-8ecc-4f8e-b817-a00b9c4a594d",
      "custom_ff793e51-669a-42e2-8670-03b838a26cf9",
      "custom_f8c54ad1-d318-447b-b9f9-7cfc236dd4c3",
      "custom_9a18ea70-1a06-4c79-83a4-7bfefc6dd95a",
      "custom_ebaa665e-77f6-4ed0-a9e2-1a0a4167b42b",
      "custom_6d6ad710-2c87-4d69-b81c-afb83ef456f2",
      "custom_799b7559-8d19-4552-8a0f-9ebd33f4e8dd",
      "custom_b0b93022-6593-463c-8103-3a7bb21a2eab",
      "custom_17f4ea3e-4d1d-49e7-9861-473c06e60821",
      "custom_0c9987f9-9ffe-48f7-b261-2383e87da7b8",
      "custom_14d81dd5-c90c-41bc-910e-394014b3c474"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": 23,
    "hiddenIds": [
      "custom_f939dd48-2c7b-4ad5-8338-97026f187caf",
      "custom_94da2cc5-e909-43a9-9ba5-9e68e9cfc53a",
      "custom_a7eca17f-219a-42b7-a443-321656e4502d",
      "custom_9458ca1e-68c2-458e-b6e9-4c37f2485200",
      "custom_e882202b-fe86-440c-9f34-31608339445d",
      "custom_3f1a79bd-03de-486e-84b9-21947183f048",
      "custom_9e463a36-ec59-422d-8763-dce04b625651"
    ],
    "orderedIds": [
      "custom_a816153a-f09f-4341-b215-99555d42d938",
      "custom_9458ca1e-68c2-458e-b6e9-4c37f2485200",
      "custom_3f1a79bd-03de-486e-84b9-21947183f048",
      "custom_a7eca17f-219a-42b7-a443-321656e4502d",
      "custom_94da2cc5-e909-43a9-9ba5-9e68e9cfc53a",
      "custom_f939dd48-2c7b-4ad5-8338-97026f187caf",
      "custom_86be3984-ef6c-43da-8cf1-bad22430751b",
      "custom_5f54ae92-0e05-4f31-aebe-7264c9457499",
      "custom_e882202b-fe86-440c-9f34-31608339445d",
      "custom_9e463a36-ec59-422d-8763-dce04b625651",
      "custom_202bf91a-e912-4fe4-99bd-d09811ab116a",
      "custom_51b14581-6e55-448d-8445-ec96d49387d7",
      "custom_926bda6d-d270-4bba-9537-1fc19ee7d861"
    ],
    "hiddenIndices": [
      1,
      2,
      4,
      8,
      5,
      7,
      10,
      15,
      14,
      34,
      13,
      16,
      21,
      23,
      24,
      17,
      19,
      22,
      18,
      20,
      25,
      29,
      30,
      26,
      27,
      32,
      37,
      28,
      43,
      39,
      41,
      44,
      45,
      46,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61,
      62,
      63,
      64,
      65,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      75,
      76,
      77
    ],
    "ordering": [
      6,
      8,
      7,
      4,
      2,
      1,
      33,
      0,
      3,
      5,
      10,
      11,
      12,
      15,
      9,
      34,
      14,
      16,
      13,
      23,
      21,
      17,
      24,
      19,
      18,
      22,
      20,
      29,
      25,
      26,
      30,
      36,
      27,
      32,
      37,
      28,
      47,
      31,
      35,
      38,
      42,
      43,
      40,
      39,
      41,
      44,
      45,
      46,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61,
      62,
      63,
      64,
      65,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      75,
      76,
      77
    ],
    "customItems": null
  },
  "gallery.images": {
    "limit": 34,
    "hiddenIds": [
      "custom_e882202b-fe86-440c-9f34-31608339445d",
      "custom_dd8461c4-b51d-46aa-a312-ab26b053cfc7",
      "custom_850fb88e-3052-4820-95c1-be7e0ac28507",
      "custom_a7eca17f-219a-42b7-a443-321656e4502d",
      "custom_4c5b160a-48b7-41af-b22a-f29a752b54ad",
      "custom_72894cc0-8b0d-4407-a12f-b138e7e24f9c",
      "custom_359b96b8-b955-411f-8038-ce87b493c938",
      "custom_a2c20008-5469-417b-b1bd-7208a9201da4",
      "custom_c6119fa3-f51f-434e-b384-9aa6873e296e",
      "custom_e78e735d-a40a-46c9-b8ba-fa5a1229231b",
      "custom_f939dd48-2c7b-4ad5-8338-97026f187caf",
      "custom_94da2cc5-e909-43a9-9ba5-9e68e9cfc53a"
    ],
    "orderedIds": [
      "custom_5f54ae92-0e05-4f31-aebe-7264c9457499",
      "custom_86be3984-ef6c-43da-8cf1-bad22430751b",
      "custom_9458ca1e-68c2-458e-b6e9-4c37f2485200",
      "custom_a816153a-f09f-4341-b215-99555d42d938",
      "custom_3f1a79bd-03de-486e-84b9-21947183f048",
      "custom_926bda6d-d270-4bba-9537-1fc19ee7d861",
      "custom_f939dd48-2c7b-4ad5-8338-97026f187caf",
      "custom_94da2cc5-e909-43a9-9ba5-9e68e9cfc53a",
      "custom_a7eca17f-219a-42b7-a443-321656e4502d",
      "custom_e882202b-fe86-440c-9f34-31608339445d",
      "custom_b32a5bb4-d0c6-44e8-a3e7-1d0a5af59332",
      "custom_e0e24601-e69b-485a-9161-6efbcaabe018",
      "custom_7c3f82a1-c104-4ead-bbfc-63208d6b74eb",
      "custom_e33f47a6-84a7-45a6-8747-c6a354959117",
      "custom_81fb265f-e919-4ae1-ac62-d411096186c7",
      "custom_fd7282d4-f502-4672-ad5d-72ac4e6659ae",
      "custom_92a36cd1-1825-45c6-a59b-6267094f13be",
      "custom_c6119fa3-f51f-434e-b384-9aa6873e296e",
      "custom_4c5b160a-48b7-41af-b22a-f29a752b54ad",
      "custom_72894cc0-8b0d-4407-a12f-b138e7e24f9c",
      "custom_359b96b8-b955-411f-8038-ce87b493c938",
      "custom_dd8461c4-b51d-46aa-a312-ab26b053cfc7",
      "custom_850fb88e-3052-4820-95c1-be7e0ac28507",
      "custom_a2c20008-5469-417b-b1bd-7208a9201da4",
      "custom_e78e735d-a40a-46c9-b8ba-fa5a1229231b"
    ],
    "hiddenIndices": [
      5,
      14,
      15,
      4,
      10,
      12,
      13,
      17,
      11,
      18,
      1,
      2
    ],
    "ordering": [
      3,
      0,
      8,
      6,
      7,
      9,
      1,
      2,
      4,
      5,
      20,
      23,
      22,
      24,
      21,
      19,
      16,
      11,
      10,
      12,
      13,
      14,
      15,
      17,
      18
    ],
    "customItems": null
  },
  "propertyoverview.apartment_amenities": {
    "limit": null,
    "hiddenIds": [
      "custom_55af916c-3248-4dd0-ba84-cffa7f248260",
      "custom_1793755c-87ba-4cfc-8674-d042f6715878",
      "custom_73ec3114-3536-4c39-8cd9-9a87878979af",
      "custom_cc1ce696-b756-4692-8a14-3b9d2386a994",
      "custom_c3002e8e-ebc3-49aa-97f4-4ca85c1363bb",
      "custom_76fcd6cd-fe42-4fe6-9bb9-0cc09fbd53a3",
      "custom_8283a881-d674-4c61-88d3-5ee247cbd879",
      "custom_b4ab4120-6fab-4fe5-bf07-a87f11ea4a6c",
      "custom_f77a2be4-d784-444a-87e2-b4b8c060cadb",
      "custom_c59fcff7-d772-41f0-960f-df1d7ee05a45",
      "custom_2920a3f1-d848-44a2-a454-3fd626ad479e"
    ],
    "orderedIds": [
      "custom_f0b0183e-d647-4c76-9b07-f53510ff775d",
      "custom_18cc9260-d74f-4517-95be-7c1bc341ff03",
      "custom_e5b3eb14-7e17-4226-a038-b56707438aa7",
      "custom_e648164c-6182-40ff-9f17-228e181cb9ea",
      "custom_b4ab4120-6fab-4fe5-bf07-a87f11ea4a6c",
      "custom_f77a2be4-d784-444a-87e2-b4b8c060cadb",
      "custom_c59fcff7-d772-41f0-960f-df1d7ee05a45",
      "custom_8283a881-d674-4c61-88d3-5ee247cbd879",
      "custom_76fcd6cd-fe42-4fe6-9bb9-0cc09fbd53a3",
      "custom_2920a3f1-d848-44a2-a454-3fd626ad479e",
      "custom_55af916c-3248-4dd0-ba84-cffa7f248260",
      "custom_1793755c-87ba-4cfc-8674-d042f6715878",
      "custom_cc1ce696-b756-4692-8a14-3b9d2386a994",
      "custom_c3002e8e-ebc3-49aa-97f4-4ca85c1363bb",
      "custom_73ec3114-3536-4c39-8cd9-9a87878979af"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.community_amenities": {
    "limit": null,
    "hiddenIds": [
      "custom_6d6ad710-2c87-4d69-b81c-afb83ef456f2",
      "custom_ebaa665e-77f6-4ed0-a9e2-1a0a4167b42b",
      "custom_799b7559-8d19-4552-8a0f-9ebd33f4e8dd",
      "custom_b0b93022-6593-463c-8103-3a7bb21a2eab",
      "custom_17f4ea3e-4d1d-49e7-9861-473c06e60821",
      "custom_0c9987f9-9ffe-48f7-b261-2383e87da7b8",
      "custom_14d81dd5-c90c-41bc-910e-394014b3c474"
    ],
    "orderedIds": [
      "custom_6bd61ea4-8ecc-4f8e-b817-a00b9c4a594d",
      "custom_ff793e51-669a-42e2-8670-03b838a26cf9",
      "custom_f8c54ad1-d318-447b-b9f9-7cfc236dd4c3",
      "custom_9a18ea70-1a06-4c79-83a4-7bfefc6dd95a",
      "custom_6d6ad710-2c87-4d69-b81c-afb83ef456f2",
      "custom_ebaa665e-77f6-4ed0-a9e2-1a0a4167b42b",
      "custom_799b7559-8d19-4552-8a0f-9ebd33f4e8dd",
      "custom_b0b93022-6593-463c-8103-3a7bb21a2eab",
      "custom_17f4ea3e-4d1d-49e7-9861-473c06e60821",
      "custom_0c9987f9-9ffe-48f7-b261-2383e87da7b8",
      "custom_14d81dd5-c90c-41bc-910e-394014b3c474"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "specialofferbanner.items": {
    "limit": null,
    "hiddenIds": [],
    "orderedIds": null,
    "hiddenIndices": [
      0
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "callrail-tracking",
      "blockId": "callrail-tracking",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9,
      "gridSpanMobile": 12
    }
  ],
  "schedule-a-tour": [
    {
      "sectionId": "elise-schedule-tour-iframe",
      "blockId": "elise-schedule-tour-iframe",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:iframe-embed": {
    "properties": {
      "overflow": "hidden"
    }
  }
};
